import { FETCH_SUCCESS } from "../constants/actions";
import { setError, setInProgress } from "./commonActions";

export const setCollection = (name, collection = []) => {
  return {
    type: `@${name}/${FETCH_SUCCESS}`,
    payload: {
      collection,
    },
  };
};

export const fetchCollectionAction = async (
  name,
  dispatch,
  service,
  params = {}
) => {
  dispatch(setInProgress(name));
  try {
    const { data } = await service(params);
    dispatch(setCollection(name, data));

    return data;
  } catch (err) {
    let message;

    if (err.response) {
      if (err.response.data) {
        message = err.response.data.message;
      }
      message = message || err.response.statusText;
    }
    const error = {
      message: message || err.message,
    };

    dispatch(setError(name, error));
  }
};
